export default __webpack_public_path__ + "static/media/horse-in-stall.0cb74904.jpeg";